import { useCallback } from "react";
import { useQueryState } from "./useQueryState";

export type TransmitterState = {
  categoryId: string;
  productId: string;
  version: string;
  model: string;
  manufacturer: string;
};

const DEFAULT: TransmitterState = {
  categoryId: "",
  productId: "",
  version: "",
  model: "",
  manufacturer: "",
};

export const useTransmitterFilter = (searchObj?: any) => {
  const stateToUse: TransmitterState = !searchObj
    ? DEFAULT
    : {
        categoryId: searchObj.categoryId ?? "",
        productId: searchObj.productId ?? "",
        version: searchObj.version ?? "",
        model: searchObj.model ?? "",
        manufacturer: searchObj.manufacturer ?? "",
      };

  const [state, setState] = useQueryState<TransmitterState>(stateToUse);

  const setTransmitterFilter = useCallback(
    (args: Partial<TransmitterState>) =>
      setState((prev) => ({ ...prev, ...args })),
    [setState],
  );

  const resetTransmitterFilter = useCallback(
    () => setState(DEFAULT),
    [setState],
  );

  return {
    transmitterFilter: state,
    setTransmitterFilter,
    resetTransmitterFilter,
  };
};
